import React from 'react'
import Title from './Title';
import { FaArrowRight } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import Bubbles from './Bubbles';

const Work = () => {
  return (
    <section id="work" className="relative bg-primary-bg py-24 overflow-hidden noise-overlay">
      <div className="absolute inset-0 grid-pattern pointer-events-none opacity-20" />
      <Bubbles count={5} />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Title>Featured Projects</Title>

        {/* Decorative empty state with animated elements */}
        <div className="mt-12 text-center" data-aos="fade-up" data-aos-duration="600">
          <div className="inline-flex items-center gap-3 text-gray-dark mb-6">
            <div className="w-12 h-[1px] bg-gradient-to-r from-transparent to-accent/30" />
            <span className="text-sm font-light tracking-widest uppercase">Portfolio</span>
            <div className="w-12 h-[1px] bg-gradient-to-l from-transparent to-accent/30" />
          </div>

          <div className="flex justify-center mb-8">
            <div className="relative">
              {/* Animated rings */}
              <div className="w-24 h-24 rounded-full border border-accent/10 animate-pulse-glow" />
              <div className="absolute inset-0 flex items-center justify-center">
                <svg className="w-10 h-10 text-accent/40" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z" />
                </svg>
              </div>
            </div>
          </div>

          <Link
            to="/projects"
            className="inline-flex items-center magnetic-btn text-accent hover:text-white text-sm font-medium transition-all duration-300 group px-6 py-3 rounded-xl border border-accent/30 hover:border-accent hover:bg-accent/10 ripple-container"
          >
            View All Projects
            <FaArrowRight className="ml-2 group-hover:translate-x-2 transition-transform duration-300" />
          </Link>
        </div>
      </div>
    </section>
  )
}

export default Work
